import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useTranslation } from 'react-i18next'

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customersList, setCustomersList] = useState([]);
  const { t } = useTranslation();

  // 初始化：從本地存儲加載用戶數據
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedCustomer = localStorage.getItem('selectedCustomer');
    
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        localStorage.removeItem('user');
      }
    }
    
    if (storedCustomer) {
      try {
        setSelectedCustomer(JSON.parse(storedCustomer));
      } catch (e) {
        localStorage.removeItem('selectedCustomer');
      }
    }
    
    setLoading(false);
  }, []);

  // 當用戶登入後，如果是客戶角色，加載其關聯的客戶列表
  useEffect(() => {
    const loadCustomers = async () => {
      if (user && user.role === 1) {
        try {
          const response = await api.get('/auth/customers');
          setCustomersList(await response.data.data);
          selectCustomer(response.data.data[0]);
          // 如果尚未選擇客戶，且有可用客戶，則選擇第一個
          // if (!selectedCustomer && response.data.data.length > 0) {
          //   selectCustomer(response.data.data[0]);
          // }
        } catch (error) {
          console.error(t('loadCustErr'), error);
        }
      }
    };
    
    if (user) {
      loadCustomers();
    }
  }, [user]);

  // 登入
  const login = async (loginId, password) => {
    try {
      // 使用正確的參數名稱 login_id
      const response = await api.post('/auth/login', {
        login_id: loginId,  // 使用正確的欄位名稱
        password
      });
      
      // console.log('登入 API 回應:', response.data);
      
      const { token, user: userData } = await response.data;
      
      // 儲存 token 到 localStorage
      localStorage.setItem('token', token);
      
      // 設置 API 請求頭的 Authorization
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // 設置用戶資訊
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));

      const detectIOS = () => { 
        const userAgent = navigator.userAgent;
        const isIOS = userAgent.includes('iPhone') || userAgent.includes('Mac OS');
        return isIOS;
      }

      if (detectIOS()) {
        localStorage.setItem('IOS', 'Y');
      } else {
        localStorage.setItem('IOS', 'N');
      }
      
      return response.data;
    } catch (error) {
      console.error('登入過程錯誤:', error);
      
      // 更詳細的錯誤記錄
      if (error.response) {
        console.error('錯誤回應數據:', error.response.data);
        console.error('錯誤回應狀態:', error.response.status);
      } else if (error.request) {
        console.error('沒有收到回應:', error.request);
      } else {
        console.error('錯誤消息:', error.message);
      }
      
      throw error;
    }
  };

  // 登出
  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('登出API錯誤', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedCustomer');
      localStorage.removeItem('IOS');
      setUser(null);
      setSelectedCustomer(null);
    }
  };

  // 選擇客戶
  const selectCustomer = (customer) => {
    setSelectedCustomer(customer);
    localStorage.setItem('selectedCustomer', JSON.stringify(customer));
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout,
      selectedCustomer,
      selectCustomer,
      customersList
    }}>
      {children}
    </AuthContext.Provider>
  );
};